import React, { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  trend?: {
    value: number;
    isPositive?: boolean;
  };
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  trend,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border border-gray-100 p-4 sm:p-6 ${className}`}>
      <div className="flex justify-between items-start">
        <div>
          <p className="text-xs sm:text-sm font-medium text-gray-600 leading-tight mb-1">{title}</p>
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{value}</h3>

          {trend && (
            <div className="mt-2 flex items-center">
              <span
                className={`text-xs sm:text-sm font-medium ${
                  trend.isPositive ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {trend.isPositive ? '+' : ''}{trend.value}%
              </span>
              <span className="text-xs text-gray-500 ml-2 hidden sm:inline">vs mois dernier</span>
            </div>
          )}
        </div>

        {icon && (
          <div className="p-2 sm:p-3 bg-gray-100 rounded-xl flex-shrink-0">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
